import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const problemAreaTypesAdapter = createEntityAdapter({})

const initialState = problemAreaTypesAdapter.getInitialState()

export const problemAreaTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getProblemAreaTypes: builder.query({
            query: () => ({
                url: '/problemAreaTypes/getProblemAreaTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedProblemAreaTypes = responseData.map(problemAreaType => {
                    problemAreaType.id = problemAreaType._id
                    return problemAreaType
                })
                return problemAreaTypesAdapter.setAll(initialState, loadedProblemAreaTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'ProblemAreaType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'ProblemAreaType', id}))
                    ]
                } else {
                    return [ { type: 'ProblemAreaType', id: 'LIST'}]
                }
            },
        }),
        createNewProblemAreaType: builder.mutation({
            query: initialProblemAreaType => ({
                url: '/problemAreaTypes/createNewProblemAreaType',
                method: 'POST',
                body: {...initialProblemAreaType,}
            }),
            invalidatesTags: [
                { type: 'ProblemAreaType', id: "LIST" }
            ] 
        }),
        updateProblemAreaType: builder.mutation({
            query: initialProblemAreaType => ({
                url: '/problemAreaTypes/updateProblemAreaType',
                method: 'PATCH',
                body: {...initialProblemAreaType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'ProblemAreaType', id: arg.id },
                { type: 'ProblemAreaType', id: 'LIST' }
            ],
        }),
        deleteProblemAreaType: builder.mutation({
            query: ({id}) => ({
                url: '/problemAreaTypes/deleteProblemAreaType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ProblemAreaType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetProblemAreaTypesQuery,
    useCreateNewProblemAreaTypeMutation,
    useUpdateProblemAreaTypeMutation,
    useDeleteProblemAreaTypeMutation,
} = problemAreaTypesApiSlice

// returns the query result object
export const selectProblemAreaTypeResult = problemAreaTypesApiSlice.endpoints.getProblemAreaTypes.select()

// create memoized selector
const selectProblemAreaTypesData = createSelector(
    selectProblemAreaTypeResult,
    problemAreaTypeResult => problemAreaTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllProblemAreaTypes,
    selectById: selectProblemAreaTypeById,
    selectIds: selectProblemAreaTypeIds,
} = problemAreaTypesAdapter.getSelectors(state => selectProblemAreaTypesData(state) ?? initialState)